module.exports = "<template> <dropdown-menu if.bind=\"actions && actions.length > 0\" actions.bind=actions context.bind=context></dropdown-menu> </template> ";